export const MAX_IMAGE_FILE_SIZE = 0.5;
export const MAX_VIDEO_FILE_SIZE = 25;
